import React, { useState } from 'react'

//Material UI
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { makeStyles } from '@material-ui/core/styles'
import {FormHelperText} from "@mui/material";

export const useStyles = makeStyles({
  select: {
    width: '100%',
    marginTop: '8px',
    marginBottom: '4px'
  }
})

export default function SelectPays(props) {

  const { register, label, defaultValue, pays, setPays, required } = props
  const name = props.name || 'pays'
  const classes = useStyles()
  const [value, setValue] = useState(defaultValue ?? '')

  const handleChange = (event) => {
    setValue(event.target.value)
    setPays(event.target.value)
  }

  return (
    <FormControl variant="outlined" className="select-form-control" style={{ width: '100%' }} required={required} error={(value?.length < 1 && required)}>
      <InputLabel className={classes.customLabel}>{label}</InputLabel>
      <Select
        native
        className={classes.select}
        margin="dense"
        label={label}
        value={value}
        onChange={handleChange}
        inputProps={{ name: name, ref: register({ required: 'Ce champ est requis' }) }}
        variant="outlined"
        defaultValue={defaultValue}
      >
        <option aria-label="None" value="" />
        {Object.values(pays).map((p, i) => (<option value={p.id} name={p.libelle} key={i}>{p.libelle}</option>))}
      </Select>
      {(value?.length < 1 && required) && <FormHelperText error>Ce champ est requis</FormHelperText>}
    </FormControl>
  )
}
